(function () {
  var canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;';
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var particles = [];
  var W, H;

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function createParticle() {
    return {
      x: rand(0, W),
      y: rand(0, H),
      r: rand(1.5, 4.5),
      vx: rand(-0.35, 0.35),
      vy: rand(-0.35, 0.35),
      opacity: rand(0.45, 0.70)
    };
  }

  function init() {
    resize();
    particles = [];
    for (var i = 0; i < 120; i++) {
      particles.push(createParticle());
    }
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(10,10,10,' + p.opacity + ')';
      ctx.fill();

      p.x += p.vx;
      p.y += p.vy;

      if (p.x < -2) p.x = W + 2;
      else if (p.x > W + 2) p.x = -2;
      if (p.y < -2) p.y = H + 2;
      else if (p.y > H + 2) p.y = -2;
    }
    requestAnimationFrame(draw);
  }

  window.addEventListener('resize', resize);
  init();
  draw();
})();
